module.exports = __webpack_public_path__ + "static/media/pause-circle.183284e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pause-circle.svg
// module id = 580
// module chunks = 0